import { AxiosInstance, AxiosResponse } from 'axios'
import { inject } from 'tsyringe'
import { httpToken } from '~/constants/dependency-injection/tokens'
import { containerScoped } from '~/decorators/dependency-container'
import { invalidBodyError } from '~/services/errors'
import { MassActionResponse } from '~/models/search/types'
import { toCamelCase } from '~/utils/object'
import RequestBuilder from '~/builders/http/RequestBuilder'
import { MassActionResponseData } from '~/models/search/mass-actions'

@containerScoped()
export default class MassActionsService {
  constructor(
    @inject(httpToken) private http: AxiosInstance,
    @inject(RequestBuilder) private requestBuilder: RequestBuilder
  ) {}

  async massTouch(
    searchId: string,
    ids?: number[]
  ): Promise<MassActionResponse> {
    const response: AxiosResponse = await this.http.post(
      '/api/classifieds/mass-actions/touch/',
      {
        search_id: searchId,
        ids
      }
    )
    const { data: body } = response
    if (!body) {
      throw invalidBodyError(body)
    }
    return toCamelCase(body)
  }

  massPriceChange({
    searchId,
    direction,
    changeType,
    change,
    ids
  }: {
    searchId: string
    direction: string
    changeType: string
    change: number
    ids?: number[]
  }): Promise<MassActionResponseData> {
    return this.requestBuilder
      .request('post', '/api/classifieds/mass-actions/price-change/')
      .data({
        search_id: searchId,
        ids,
        direction,
        change_type: changeType,
        change
      })
      .send()
  }

  massShow({
    searchId,
    ids
  }: {
    searchId: string
    ids?: number[]
  }): Promise<MassActionResponseData> {
    return this.requestBuilder
      .request('post', '/api/classifieds/mass-actions/show/')
      .data({
        search_id: searchId,
        ids
      })
      .send()
  }

  massHide({
    searchId,
    ids
  }: {
    searchId: string
    ids?: number[]
  }): Promise<MassActionResponseData> {
    return this.requestBuilder
      .request('post', '/api/classifieds/mass-actions/hide/')
      .data({
        search_id: searchId,
        ids
      })
      .send()
  }

  async massCustomPage(
    searchId: string,
    customSearchIds: number[],
    ids?: number[]
  ): Promise<MassActionResponse> {
    const response: AxiosResponse = await this.http.post(
      '/api/classifieds/mass-actions/custom-page/',
      {
        search_id: searchId,
        ids,
        custom_search_ids: customSearchIds
      }
    )
    const { data: body } = response
    if (!body) {
      throw invalidBodyError(body)
    }
    return toCamelCase(body)
  }
}
